import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private config: any;
  public configSubject$: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {}

  public loadConfig() {
    console.log('new config service');
    return this.http
      .get('./assets/configs/config.json')
      .toPromise()
      .then((config: any) => {
        this.config = config;
        this.configSubject$.next(this.config);
      })
      .catch((err: any) => {
        console.error(err);
      });
  }

  getConfig() {
    return this.config;
  }
}
